export class BooleanRef {
    value: boolean = false;
}